import { withNamespaces } from 'react-i18next';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';

const CreateConfirmModal = ({
    t,
    isOpen,
    toggle,
    onConfirm,
    isSubmitting,
    thirdPartyName,
}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                {t('Confirm Third Party Creation')}
            </ModalHeader>
            <ModalBody>
                <p className="mb-2">
                    {t('You are about to create a new third party.')}
                </p>
                {thirdPartyName && (
                    <p className="fw-semibold mb-2">
                        {thirdPartyName}
                    </p>
                )}
                <p className="text-muted mb-0">
                    {t('Please review the information below and confirm to proceed. You can still go back and make changes if needed.')}
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" outline onClick={toggle} disabled={isSubmitting}>
                    {t('Cancel')}
                </Button>
                <Button color="primary" onClick={onConfirm} disabled={isSubmitting}>
                    {isSubmitting ? (
                        <>
                            <Spinner size="sm" color="white" className="me-2" />
                            {t('Creating')}...
                        </>
                    ) : (
                        t('Confirm & Create')
                    )}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(CreateConfirmModal);
